/* eslint-disable */

/** unique or primary key constraints on table "argo.location" */
export enum ArgoLocationConstraint {
  /** unique or primary key constraint on columns "context_id", "is_default" */
  LocationIsDefaultPerContext = 'location_is_default_per_context',
  /** unique or primary key constraint on columns "context_id", "name" */
  LocationNameKey = 'location_name_key',
  /** unique or primary key constraint on columns "location_id" */
  LocationPkey = 'location_pkey'
}

/** select columns of table "argo.location" */
export enum ArgoLocationSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LocationClassId = 'location_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ParentLocationId = 'parent_location_id',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_location_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.location" */
export enum ArgoLocationSelectColumnArgoLocationAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsDefault = 'is_default'
}

/** select "argo_location_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.location" */
export enum ArgoLocationSelectColumnArgoLocationAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsDefault = 'is_default'
}

/** update columns of table "argo.location" */
export enum ArgoLocationUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LocationClassId = 'location_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ParentLocationId = 'parent_location_id',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

